import liteMatter from "lite-matter";

interface MarkdownResult {
  frontmatter: Record<string, unknown>;
  content: string;
  path: string;
}

interface Manifest {
  files: any[];
  categories: Record<string, unknown>;
}

export const loadMarkdown = async (
  path: string,
): Promise<MarkdownResult | null> => {
  try {
    const response = await fetch(`/docs/${path}.md`);
    if (!response.ok) return null;

    const text = await response.text();
    const { data, content } = liteMatter(text);

    return {
      frontmatter: data,
      content,
      path,
    };
  } catch (error) {
    console.error("Failed to load markdown:", error);
    return null;
  }
};

export const getMarkdownList = async (type: string): Promise<string[]> => {
  try {
    const manifestResponse = await fetch(`/docs/${type}/manifest.json`);

    if (!manifestResponse.ok) {
      throw new Error(`Failed to fetch manifest: ${manifestResponse.status}`);
    }

    const text = await manifestResponse.text();
    const manifest: Manifest = JSON.parse(text);
    return manifest.files;
  } catch (error) {
    console.error("Failed to load manifest:", error);
    return [];
  }
};

export const getManifest = async (type: string): Promise<Manifest> => {
  try {
    const manifestResponse = await fetch(`/docs/${type}/manifest.json`);

    if (!manifestResponse.ok) {
      throw new Error(`Failed to fetch manifest: ${manifestResponse.status}`);
    }

    const text = await manifestResponse.text();
    const manifest: Manifest = JSON.parse(text);
    return manifest;
  } catch (error) {
    console.error("Failed to load manifest:", error);
    return { files: [], categories: {} };
  }
};

export const getDescriptions = async (
  slugs: string[],
): Promise<Record<string, string>> => {
  try {
    const descriptions: Record<string, string> = {};
    await Promise.all(
      slugs.map(async (slug) => {
        const data = await loadMarkdown(`guides/${slug}`);
        if (data?.frontmatter?.description) {
          descriptions[slug] = data.frontmatter.description as string;
        }
      }),
    );
    return descriptions;
  } catch (error) {
    console.error("Failed to load descriptions:", error);
    return {};
  }
};
